<template>
  <ion-app>
    <!-- Header estilo TuBus -->
    <div class="tb-header">
      <div class="tb-logo">
        <span class="tb-buspin">🚌</span> Tu<span class="tb-accent">Bus</span>
      </div>
      <div class="tb-sub">Monitoreo Municipal — Control de Rutas (MVP)</div>
      <div class="tb-live"><i></i> EN VIVO</div>
    </div>

    <ion-segment v-model="sim.tab" class="tb-segment">
      <ion-segment-button value="mapa">
        <ion-icon :icon="mapOutline" /><ion-label>Mapa</ion-label>
      </ion-segment-button>
      <ion-segment-button value="rutas">
        <ion-icon :icon="listOutline" /><ion-label>Rutas</ion-label>
      </ion-segment-button>
      <ion-segment-button value="datos">
        <ion-icon :icon="serverOutline" /><ion-label>Datos</ion-label>
      </ion-segment-button>
    </ion-segment>

    <map-view :active="sim.tab === 'mapa'" />
    <routes-view v-show="sim.tab === 'rutas'" />
    <data-view v-show="sim.tab === 'datos'" />
  </ion-app>
</template>

<script setup>
import { IonApp, IonSegment, IonSegmentButton, IonLabel, IonIcon } from '@ionic/vue';
import { mapOutline, listOutline, serverOutline } from 'ionicons/icons';
import { sim } from './stores/simulation';
import MapView from './views/MapView.vue';
import RoutesView from './views/RoutesView.vue';
import DataView from './views/DataView.vue';
</script>

<style>
/* Header TuBus */
.tb-header {
  background: linear-gradient(135deg, #0E133F 0%, #1A237E 60%, #2733B8 100%);
  color: #fff; padding: 18px 18px 14px;
  box-shadow: 0 2px 12px rgba(20, 26, 94, .35);
  flex: 0 0 auto; position: relative; z-index: 5;
}
.tb-logo { font-size: 26px; font-weight: 800; letter-spacing: .5px; display: flex; align-items: center; gap: 8px; }
.tb-logo .tb-buspin {
  background: #fff; color: var(--tb-navy); border-radius: 12px;
  width: 38px; height: 38px; display: flex; align-items: center; justify-content: center; font-size: 20px;
}
.tb-logo .tb-accent { color: var(--tb-blue); }
.tb-sub { font-size: 12px; opacity: .85; margin-top: 4px; letter-spacing: .3px; }
.tb-live {
  position: absolute; top: 18px; right: 16px;
  background: rgba(255, 255, 255, .15); border: 1px solid rgba(255, 255, 255, .35);
  padding: 4px 10px; border-radius: 999px; font-size: 11px;
  display: flex; align-items: center; gap: 6px;
}
.tb-live i {
  width: 8px; height: 8px; border-radius: 50%; background: #4ADE80; display: inline-block;
  animation: tb-pulse 1.6s infinite;
}
@keyframes tb-pulse { 0%, 100% { opacity: 1; } 50% { opacity: .35; } }

ion-segment.tb-segment {
  --background: #fff; --color-checked: var(--tb-navy); --indicator-color: var(--tb-navy);
  border-radius: 14px; margin: 12px 14px 0; max-width: 560px; align-self: center;
  width: calc(100% - 28px); box-shadow: 0 2px 8px rgba(20, 26, 94, .10); flex: 0 0 auto;
}
ion-segment.tb-segment ion-segment-button { min-height: 44px; --color: var(--tb-muted); --color-checked: var(--tb-navy); }
ion-segment.tb-segment ion-icon { font-size: 18px; margin-right: 4px; vertical-align: -3px; }
</style>
